<gbc-tile [title]="'create-edit-igrid-installation.data-point.title' | translate">
  @if (dataPoints && dataPoints.length > 0) {
    <gbc-table>
      <th gbc-table-header>
        {{ 'create-edit-igrid-installation.data-point.key' | translate }}
      </th>
      <th gbc-table-header>
        {{ 'create-edit-igrid-installation.data-point.name' | translate }}
      </th>
      <th gbc-table-header>
        {{ 'create-edit-igrid-installation.data-point.unit' | translate }}
      </th>
      <th gbc-table-header>
        {{ 'create-edit-igrid-installation.data-point.state' | translate }}
      </th>
      @for (dataPoint of dataPoints; track dataPoint) {
        <tr gbc-table-row>
          <td gbc-table-cell class="title">
            {{ dataPoint.dataKey }}
          </td>
          <td gbc-table-cell>
            {{ 'igrid-installation-datapoints.' + dataPoint.standardKey | translate }}
          </td>
          <td gbc-table-cell>
            {{ dataPoint.dataPointType }}
          </td>
          <td gbc-table-cell>
            @if (getStateDetails(dataPoint.action); as stateDetails) {
              @if (stateDetails.svgUrl) {
                <img
                  [src]="stateDetails.svgUrl"
                  height="29px"
                  width="29px"
                  alt="SVG for {{ dataPoint.action }} action"
                  />
              }
              {{ stateDetails.messageKey | translate }}
            }
          </td>
        </tr>
      }
    </gbc-table>
  } @else {
    <p class="no-available-data-points">
      {{ 'create-edit-igrid-installation.data-point.missing' | translate }}
    </p>
  }
</gbc-tile>
